import useApiController from "@hooks/useApiController"
import { Descendant } from "slate"

export default function useSalonController(): Admin.Controllers.Salon {
    const { index, store, show, update, destroy, ...controller } = useApiController('/api/admin/salons')

    const customers = (id: string | number) => controller.get(`${id}/customers`)
    const juries = (id: string | number) => controller.get(`${id}/juries`)
    const togglePaid = (salonId: string | number, userId: string | number) => controller.patch(`${salonId}/${userId}/status`)
    const best = (salonId: string | number, userId: string | number) => controller.patch(`${salonId}/${userId}/best`)
    const type = (salonId: string | number, type: Attributes.Salon.Type) => controller.patch(`${salonId}/type`, { type })
    const conditions = (salonId: string | number, conditions: Descendant[]) => controller.patch(`${salonId}/conditions`, { conditions })

    return { index, store, show, update, destroy, customers, juries, togglePaid, best, type, conditions }
}